"use client";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import React from "react";

const disclaimerBreadcrumbPaths: BreadcrumbPath[] = [
    { label: "Home", route: "/" },
    { label: "Disclaimer" },
];

const Disclaimer = () => {
    return (
        <section className="md:px-auto mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:px-36 md:pb-[120px] md:pt-0">
            <Breadcrumb paths={disclaimerBreadcrumbPaths} />
            {/* <h2 className="mb-4 text-2xl font-semibold md:mb-8 md:text-4xl">
                Disclaimer for investments in Unlisted Equities / Pre IPO shares:
            </h2>
            <p className="mb-8 text-base text-neutral-500">
                Investment in Pre-IPO / Unlisted Equities / Shares are subject to risk. This
                communication/ report / note / one-pager is general and educational in nature.
                <b>ETA Fintech Private Limited under the brand name ‘InCred Money’</b> and its
                representatives are not SEBI-registered research analysts or advisors. Any research,
                analysis, or information presented on this platform does not constitute investment
                advice or a recommendation by InCred Money or its affiliates.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                We do not make warranties as to the quality of the company, disclosures, IPO
                timelines, valuations or any other matter. It is specifically informed that if you
                enter into the buy transaction, it shall be on the basis that you have understood
                and agreed that we and/or our group company/ies shall be the counter party to the
                transaction and you shall have no objections to the same at a later date. You are
                solely responsible for your decision to invest or NOT.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                The information mentioned on the platform is based on publicly available data and to
                the best of our knowledge, does not constitute insider information. The Logos
                displayed belong to the respective company(ies) and do not belong to us and are used
                for representation purpose only. It is neither an advertisement nor a solicitation
                or offer to buy or sell any financial instruments or to engage in any specific
                trading strategy. Nothing in this document represents that any investment strategy
                or recommendation is suitable for an investor’s individual circumstances or
                otherwise constitutes personal advice.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Prospective Investor confirms that no offers or invitations, solicitations of any
                offer, advice, representations, warranties, or recommendations (verbal or written)
                have been given or made to investor by the InCred in respect of the purchase
                instruction / transaction.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                None of InCred Money or its representatives is responsible for providing investment
                advice in a fiduciary capacity or otherwise. Recipients are solely liable for any
                liabilities incurred and will indemnify InCred Money, its group companies,
                employees, or business partners for any liabilities it may incur in this respect.
                Investments involve risks, and investors should exercise prudence and their own
                judgement in making investment decisions.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                {`None of InCred Money, its representatives, partners, or business associates suggests that the recipient or any other person take any specific action. By receiving this document, the recipient acknowledges and agrees with its intended purpose and further disclaims any expectation or belief that the information constitutes investment advice or otherwise meets the recipient's investment objectives.`}
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Investors are strongly encouraged to perform their own thorough research and due
                diligence before making any investment decisions. Unlisted equities carry a higher
                risk profile compared to listed securities, including but not limited to liquidity
                risk, regulatory risk, and market volatility. Potential investors should be aware of
                these risks and consider them carefully. Prospective investors understand that the
                investment in unlisted shares is only suitable for those who are aware of,
                understand the risks involved in and all the specificities and are able to withstand
                the related risk and possible loss of their entire committed capital and investor
                accepts the same.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Prospective Investor is placing instructions to invest in above mentioned unlisted
                share on his/her/its own independent and free will after due consideration of
                his/her/its risk appetite, investment needs and financial situation without being
                influenced by any advice or solicitation by InCred Money or any of its group
                companies or officials.
            </p>

            <p className="mb-8 text-base text-neutral-500">
                After selling unlisted shares to the investor, InCred Money shall not be liable for
                fluctuation in price or demand of these shares.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                The value of any investment or income can decrease as well as increase, and
                investors may not get back the full (or any) amount invested. Past performance is
                not necessarily indicative of future results. Neither InCred Money nor any of its
                directors, employees, partners, group companies, business associates, or agents
                accept any liability for any loss (including principal loss) or damage arising from
                the use of all or any of the information provided.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Before making any investment or financial decisions, recipients of this document
                should take steps to understand the risks and returns of the investment and seek
                personalized advice from their financial, legal, tax, and other professional
                advisors, considering all their specific circumstances.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Any prices stated in this document are for information purposes only and do not
                represent valuations for individual securities or other financial instruments. We do
                not assure principal protection or any guaranteed returns, and future performance is
                subject to market conditions. There is no representation that any transaction can or
                could have been effected at those prices, and any prices do not necessarily reflect
                our internal books and records or theoretical model-based valuations and may be
                based on certain assumptions. Different assumptions by us or any other source may
                yield different results. No representation or warranty, either expressed or implied,
                is provided regarding the accuracy, completeness, or reliability of the information
                contained in any materials to which this document relates.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                There is no assurance of exit and listing date, and no clarity on whether the IPO
                will occur. Unlisted shares are subject to a lock-in period of six months from the
                date of listing. The information provided is not intended to be a complete statement
                or summary of the securities, markets, or developments referred to in the document.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                We may have used primary or secondary data on the product or any company’s
                information, and there is no assurance that this data is correct.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                We shall not be liable for any losses that recipients may suffer due to any
                investment or disinvestment decision based on the communication or information or
                recommendations/ updates received from us on any product. InCred Money does not
                undertake to update or keep the information current.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Prospective Investor understands that InCred Money has not undertaken and is not
                under any obligation to undertake any due diligence to assess and advise on the
                risks or suitability of Unlisted shares being invested in by the Investor.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                {`Any opinions expressed in this document may change without prior notice. Under no circumstances may this document or any of the information (including any forecast, value, index, or another calculated amount ("Values")) be used for valuation or accounting purposes: (i) valuation or accounting purposes; (ii) to determine amounts due or payable, the price, or the value of any financial instrument, financial contract, tangible or intangible assets; or (iii) to measure the performance of any financial instrument, including, without limitation, for the purpose of tracking the return or performance of any value or defining the asset allocation of a portfolio or computing performance fees.`}
            </p>
            <p className="mb-8 text-base text-neutral-500">
                ETA Fintech Private Limted is acting in the capacity of referral partner. By
                registering FD through this platform you will be registered as a direct client of
                Bank / NBFC.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                {`The information provided by our blog is educational only and is not investment or tax advice. The author of the report and / or the employees of InCred Money may have interest / position in the instruments discussed in the blog post or InCred Money advisory. Our team has, to the best of its ability, taken into account various factors - both quantitative measures and qualitative assessments, in an unbiased manner, while choosing the fund(s) mentioned in InCred Money advisory or our blog. However, they carry unknown risks and uncertainties linked to broad markets, as well as analysts' expectations about future events. They should not, therefore, be the sole basis of investment decisions.`}
            </p>
            <p className="mb-8 text-base text-neutral-500">
                {`None of the information displayed on or downloadable from `}
                <a href="https://www.incredmoney.com" target="_blank" rel="noopener noreferrer">
                    www.incredmoney.com
                </a>
                {` (the "website") represents an offer to buy or sell or a solicitation of an offer to buy or sell any bond, nor does it constitute an offer to provide investment advice or service. Registered representatives, subsidiaries, employees and directors of ETA Fintech Pvt Ltd do not (1) Advise any member on the merits or advisability of a particular investment or transaction, or (2) Assist in the determination of fair value of any investment, or (3) Provide legal, tax, or transactional advisory services.`}
            </p> */}
            <h2 className="mb-8 text-2xl font-semibold md:mb-8 md:text-4xl">
                Disclaimer for Fixed Deposits
            </h2>
            <p className="mb-8 text-base text-neutral-500">
                Investments in debt securities/municipal debt securities/securitised debt
                instruments are subject to risks including delay and/or default in payment. Read all
                the offer related documents carefully.
            </p>
            <p className="mb-8 text-base text-neutral-500">
                Fixed Deposits are offered by Banks/NBFCs and are regulated by the Reserve Bank of
                India. ETA Fintech Private Limited, under the brand name of InCred Money, is
                acting in the capacity of Sub Agent/Referral Partner for distribution of Fixed
                Deposits of Banks and NBFCs. The funds transferred by the customer for the Fixed
                Deposits are directly credited to the regulated entity offering the Fixed Deposit
                product. Fixed Deposits are offered to Resident Indians above the age of 18 who have
                a PAN & an Aadhaar. Interest rates are subject to change and may vary based on the
                tenure selected.{" "}
                <a
                    href="http://www.incredmoney.com/terms-of-use"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-brand-blue-500"
                >
                    *T&C Apply
                </a>
                .
            </p>
            <h2 className="mb-8 text-2xl font-semibold md:mb-8 md:text-4xl">
                Disclaimer: Digital Gold/Silver Transactions on InCred Money
            </h2>
            <p className="mb-8 text-base text-neutral-500">
                ETA Fintech Private Limited, operating under the brand name &ldquo;InCred
                Money,&ldquo; provides a digital platform that facilitates the purchase and sale of
                &ldquo;Digital Gold/Silver.&ldquo; The contractual relationship in relation to the
                Digital Gold/Silver is exclusively between the Client and MMTC-PAMP India Private
                Limited (&ldquo;MMTC&ldquo;). InCred Money acts strictly as a referral partner and
                technology facilitator, providing a platform to these transactions. The
                Client&apos;s use of the InCred Money platform for any Digital Gold/Silver
                transaction constitutes an express agreement and acknowledgement of this
                arrangement.
                <br />
                <br />
                By initiating any transaction for Digital Gold/Silver on the InCred Money platform,
                the Client hereby represents and warrants that they have read, understood, and
                unequivocally agree to be bound by the terms and conditions of service, as well as
                the disclaimers of representation and warranties, as stipulated under{" "}
                <a
                    href="http://www.incredmoney.com/terms-of-use"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                >
                    incredmoney.com/terms-of-use
                </a>
                . It is the Client&apos;s sole responsibility to review and comprehend the agreement
                it signs with MMTC prior to undertaking any transaction. The initiation of a
                transaction shall be deemed as the Client&apos;s conclusive acceptance of the said
                terms and disclaimers.
                <br />
                <br />
                The Client acknowledges and agrees that all aspects of the Digital Gold/SIlver,
                including but not limited to its delivery, quality, quantity, purity, and custodial
                arrangements, are the exclusive responsibility and liability of MMTC. InCred Money
                shall not be held liable, at any point in time or under any circumstances, for the
                quality, delivery, or any other matter pertaining to the Digital Gold/SIlver
                transacted between the Client and MMTC. InCred Money makes no representations or
                warranties, express or implied, with respect to the Digital Gold/Silver offered by
                MMTC.
                <br />
                <br />
                Any complaints or grievances related to the quality, delivery, or other aspects of
                the Digital Gold/Silver must be addressed directly with MMTC. InCred Money may, at
                its sole discretion, assist in facilitating communication between the Client and
                MMTC as a courtesy, but is under no obligation to do so. InCred Money assumes no
                liability or responsibility arising from such facilitation. Resolution of any
                disputes or grievances is exclusively between the Client and MMTC.
                <br />
                <br />
                InCred Money hereby discloses that it receives remuneration from MMTC for the
                facilitation of Digital Gold/Silver transactions conducted through its platform,
                pursuant to a pre-existing commercial arrangement between InCred Money and MMTC.
                Investment in digital gold & silver is at your own risk & discretion. Please read
                the terms, conditions and disclaimers on the InCred Money & MMTC-PAMP web platform
                prior to any purchase.
                <br />
                <br />
                Investment in digital gold & silver is at your own risk & discretion. Please read
                the terms, conditions and disclaimers on the InCred Money & MMTC-PAMP web platform
                prior to any purchase.
            </p>
        </section>
    );
};

export default Disclaimer;
